import UserListEntry from '../../models/UserListEntry'
import PropertyMetasConverter from './PropertyMetasConverter'
import ScoreDetailsInfoConverter from './ScoreDetailsInfoConverter';

class UserListEntryConverter {
    static convert({ id, stockId, symbol, companyName, score, thresholds, isPriceIntraDay, marketCap, oneYearLow, oneYearHigh, propertiesMetas, currency, plateformCustomExchange, scoreDetailsInfo }) {
        const propertyMetasList = PropertyMetasConverter.convert({ propertiesMetas });
        const sdi = ScoreDetailsInfoConverter.convert({ scoreDetailsInfo });
        return new UserListEntry({ id, stockId, symbol, companyName, score, thresholds, isPriceIntraDay, marketRegularPrice: propertyMetasList.price, marketCap, oneYearLow, oneYearHigh, change: propertyMetasList.change, changePercent: propertyMetasList.change_percent, currency, plateformCustomExchange, scoreDetailsInfo: sdi });
    }
}

export default UserListEntryConverter
